import { createSlice } from '@reduxjs/toolkit';

const disclaimerDialog = createSlice({
	name: 'disclaimerDialog',
	initialState: {
		shown: false,
	},
	reducers: {
		show: (state) => ({
			...state,
			shown: true,
		}),
		hide: (state) => ({
			...state,
			shown: false,
		}),
	},
});

export default disclaimerDialog;
